module.exports = __webpack_public_path__ + "static/rss_white-45f60432e9f0e764bcfc4459c108f415.png";